import { environment } from '@fb/environments';
import { FloatingButtonEnvironmentOverrides } from '@fb/models';

const OVERRIDE_KEYS = ['apiHost', 'wssHost', 'lmsHost'] as const satisfies ReadonlyArray<
  keyof FloatingButtonEnvironmentOverrides
>;

const baselineHosts: Required<FloatingButtonEnvironmentOverrides> = {
  apiHost: environment.apiHost,
  wssHost: environment.wssHost,
  lmsHost: environment.lmsHost,
};

export function applyFloatingButtonEnvironmentOverrides(
  overrides?: FloatingButtonEnvironmentOverrides | null,
): void {
  const next: Required<FloatingButtonEnvironmentOverrides> = { ...baselineHosts };

  if (overrides) {
    for (const key of OVERRIDE_KEYS) {
      const value = overrides[key];

      if (value != null && value !== '') {
        next[key] = value;
      }
    }
  }

  Object.assign(environment, next);
}
